import moment from 'moment';

/**
 *  Magic number for one second in milliseconds.
 */
export const Second = 1000;
/**
 *  Magic number for one minute in milliseconds.
 */
export const Minute = 60000;
/**
 *  Magic number for one hour in milliseconds.
 */
export const Hour = 3600000;

/**
 *  Add units of specific interval to the given date.
 */
export function dateAdd(date, interval, units) {
  var ret = new Date(date); //don't change original date
  switch (interval.toLowerCase()) {
    case 'year':
      ret.setFullYear(ret.getFullYear() + units);
      break;
    case 'quarter':
      ret.setMonth(ret.getMonth() + units * 3);
      break;
    case 'month':
      ret.setMonth(ret.getMonth() + units);
      break;
    case 'week':
      ret.setDate(ret.getDate() + units * 7);
      break;
    case 'day':
      ret.setDate(ret.getDate() + units);
      break;
    case 'hour':
      ret.setTime(ret.getTime() + units * Hour);
      break;
    case 'minute':
      ret.setTime(ret.getTime() + units * Minute);
      break;
    case 'second':
      ret.setTime(ret.getTime() + units * Second);
      break;
    default:
      ret = undefined;
      break;
  }
  return ret;
}

export function toUtcMidnight(value) {
  if (!value) {
    return value;
  }

  const day =
    value instanceof Date ? moment(value).format('YYYY-MM-DD') : value;

  return moment.utc(day, 'YYYY-MM-DD').toDate();
}
